import { isDestinationTemplateName, isProductTemplateName } from '@/cms/constants/template-names'
import { AllCMSPageFields } from '@/cms/fields/mappers/common'
import { Configuration } from '@/scopes/common/domain/types/configuration'
import { MetaTitleResolver } from '@/scopes/common/domain/types/meta-data'
import { IntlShape } from 'react-intl'
import { createCmsDestinationMetaTitleResolver } from './destination/cmsDestinationMetaTitleResolver'
import { createCmsProductMetaTitleResolver } from './product/cmsProductMetaTitleResolver'

interface MetaTitleResolverDependencies {
  config: Configuration
  cmsFields: AllCMSPageFields
  intl: IntlShape
}

export function createCmsMetaTitleResolver({ config, cmsFields, intl }: MetaTitleResolverDependencies): MetaTitleResolver {
  if (isDestinationTemplateName(cmsFields.template)) {
    return createCmsDestinationMetaTitleResolver({ config, cmsFields, intl })
  }

  if (isProductTemplateName(cmsFields.template)) {
    return createCmsProductMetaTitleResolver({ config, cmsFields, intl })
  }

  return {
    resolve: () => config.brandName,
  }
}
